import { Component } from '@angular/core';

@Component({
  selector: 'franbase-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'backend';
}
